import React from 'react'
import Vantcomp from '../../components/caseComponent/vantComp/vantcomp'

const Vant = () => {
  return (
   <section >
     <Vantcomp />
   </section>

  )
}

export default Vant
